// Maximal evenness (Clough–Douthett): spread k onsets over n slots as evenly
// as arithmetic allows — floor(i·n/k). One formula, many famous outputs: the
// diatonic scale is ME(7,12), the pentatonic ME(5,12), the °7 ME(4,12), the
// octatonic ME(8,12); over rhythm it gives Toussaint's Euclidean rhythms
// (tresillo ME(3,8), cinquillo ME(5,8)). It is the same maths as Bresenham's
// line algorithm and the placement of leap years.

/** The maximally even k-of-n selection, optionally rotated. */
export function maximallyEven(k: number, n: number, rotation = 0): number[] {
  if (k <= 0 || n <= 0) return [];
  const kk = Math.min(k, n);
  const out = new Set<number>();
  for (let i = 0; i < kk; i++) {
    out.add((Math.floor((i * n) / kk) + rotation + n * 4) % n);
  }
  return [...out].sort((a, b) => a - b);
}

/** Successive gaps around the cycle (a maximally even set uses ≤2 sizes). */
export function gapPattern(onsets: number[], n: number): number[] {
  if (onsets.length === 0) return [];
  return onsets.map((p, i) => {
    const next = onsets[(i + 1) % onsets.length];
    return ((next - p) % n + n) % n || n;
  });
}

/** True when `a` is some rotation of `b` within Z_n. */
export function isRotationOf(a: number[], b: number[], n: number): boolean {
  if (a.length !== b.length) return false;
  const key = (xs: number[]) => [...xs].sort((x, y) => x - y).join(',');
  const ka = key(a);
  for (let r = 0; r < n; r++) {
    if (key(b.map((p) => (p + r) % n)) === ka) return true;
  }
  return false;
}
